import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error - TS2724 - '"react"' has no exported member named 'Element'. Did you mean 'CElement'?
import React from "react";
import useUniqueId from "../../Hooks/useUniqueId";
import { UPLOAD_CONFIG, validateFileExtensions } from "../../../Config/upload.config";
/**
 * A button which opens a file dialog and provides the selected files in the onChange handler.  Note that this is
 * different from other inputs.  This button does not have a 'value'.
 *
 * This works by creating a hidden file input and then clicking that input when the button is clicked.
 */
const FileButton = (props) => {
    const fileRef = React.useRef();
    const uniqueId = useUniqueId()[0] + "-fileLoader";
    const validateFiles = (fileList) => {
        var _a, _b, _c, _d;
        const files = [];
        if (!fileList)
            return files;
        // Convert FileList to File array
        for (let i = 0; i < fileList.length; i++) {
            files.push(fileList[i]);
        }
        // Check number of files per batch (DoS protection)
        if (files.length > UPLOAD_CONFIG.MAX_FILES) {
            (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, `Maximum ${UPLOAD_CONFIG.MAX_FILES} files can be uploaded at once. Please select fewer files and try again.`);
            return [];
        }
        // Check total files including existing queue (prevent queue accumulation)
        const existingCount = props.existingFilesCount || 0;
        if (existingCount + files.length > UPLOAD_CONFIG.MAX_FILES) {
            (_b = props.onError) === null || _b === void 0 ? void 0 : _b.call(props, `Cannot add ${files.length} file(s). Maximum ${UPLOAD_CONFIG.MAX_FILES} files total. Currently ${existingCount} files in queue.`);
            return [];
        }
        // Check file extensions
        const extensionValidation = validateFileExtensions(files);
        if (!extensionValidation.isValid) {
            (_c = props.onError) === null || _c === void 0 ? void 0 : _c.call(props, extensionValidation.error || "Invalid file type(s) selected.");
            return [];
        }
        // Check each file's size (unless parent component will handle it)
        if (!props.skipSizeValidation) {
            for (const file of files) {
                if (file.size > UPLOAD_CONFIG.MAX_FILE_SIZE) {
                    (_d = props.onError) === null || _d === void 0 ? void 0 : _d.call(props, `File "${file.name}" exceeds maximum size of ${UPLOAD_CONFIG.MAX_FILE_SIZE_DISPLAY}`);
                    return [];
                }
            }
        }
        return files;
    };
    return (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: uniqueId, hidden: true, className: "sr-only", children: "File" }), _jsx("input", { className: "d-none", type: "file", id: uniqueId, 
                // @ts-expect-error - TS2322 - Type 'MutableRefObject<HTMLInputElement | null | undefined>' is not assignable to type 'LegacyRef<HTMLInputElement> | undefined'.
                ref: fileRef, name: "files", accept: props.accept, onChange: (e) => {
                    const validatedFiles = validateFiles(e.target.files);
                    if (validatedFiles.length > 0) {
                        props.onChange(validatedFiles);
                    }
                    // Reset input value to allow selecting the same files again
                    e.target.value = "";
                }, multiple: true }), React.cloneElement(props.button, {
                onClick: (...args) => {
                    if (props.button.props.onClick) {
                        props.button.props.onClick(...args);
                    }
                    if (fileRef.current) {
                        fileRef.current.click();
                    }
                },
            })] }));
};
export default FileButton;
